import React, { useMemo } from 'react';
import styled from 'styled-components';
import { TextSimpleData } from '../../shared/dto/EntityRepository';
import {
  IMPORT_STATION_TEXT_AUTHOR_MAX_LENGTH,
  IMPORT_STATION_TEXT_TITLE_MAX_LENGTH,
} from '../../shared/constants/limits';
import { useImportStationTextStore } from '../../shared/store/importStationTextStore';
import { shrinkString } from '../../shared/util/shrinkString';

interface SimpleTextProps {
  data: TextSimpleData;
  onClickHandler: (textId: string) => void;
}

const SimpleText: React.FC<SimpleTextProps> = ({ data, onClickHandler }) => {
  const { selectedId } = useImportStationTextStore();
  const isSelected = selectedId === data.id;
  const shrinkedTitle = useMemo(
    () => shrinkString(data.title, IMPORT_STATION_TEXT_TITLE_MAX_LENGTH),
    [data.title],
  );
  const shrinkedAuthor = useMemo(
    () => shrinkString(data.author, IMPORT_STATION_TEXT_AUTHOR_MAX_LENGTH),
    [data.author],
  );

  return (
    <SimpleWorkComp key={data.id} $isSelected={isSelected} onClick={() => onClickHandler(data.id)}>
      <SimpleTitle title={data.title}>{shrinkedTitle}</SimpleTitle>
      <SimpleAuthor $isSelected={isSelected} title={data.author}>{shrinkedAuthor}</SimpleAuthor>
    </SimpleWorkComp>
  );
};

const SimpleWorkComp = styled.div<{ $isSelected?: boolean }>`
  width: 100%;
  min-height: clamp(20px, 10vw, 40px);
  height: clamp(20px, 10vw, 40px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  box-shadow: ${({ $isSelected }) =>
    $isSelected
      ? 'inset 1px 1px 3px 0 rgba(0, 0, 0, 0.25), inset -1px -1px 5px 0 rgba(255, 255, 255, 0.7)'
      : 'inset 1px 1px 3px 0 rgba(255, 255, 255, 0.35), inset -1px -1px 3px 0 rgba(0, 0, 0, 0.2)'};
  padding: 0 10px;
  color: ${({ theme, $isSelected }) => ($isSelected ? theme.colors.color_Gray_04 : 'inherit')};
  cursor: pointer;
  &:hover {
    transform: scale(0.98);
  }
  transition: all 0.3s ease-in-out;
`;

const SimpleTitle = styled.div`
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  ${({ theme }) => theme.typography.Body_03_1};
`;

const SimpleAuthor = styled.div<{ $isSelected?: boolean }>`
  flex-shrink: 0;
  max-width: 40%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  ${({ theme }) => theme.typography.Body_04};
  color: ${({ theme, $isSelected }) => ($isSelected ? theme.colors.color_Gray_04 : theme.colors.color_Gray_03)};
`;

export default SimpleText;